<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      logo: "",
    };
  },
  mounted() {
    this.logo = "http://wap.haicon.cn/static/logo_pc.png";
  },
  components: {},
  methods: {},
};
</script>

<style scoped></style>